export type ConsentPreferences = {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
  preferences: boolean;
};

const STORAGE_KEY = "site_consent_v2";

export const defaultConsent: ConsentPreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
  preferences: false,
};

export function getConsent(): ConsentPreferences {
  try {
    const raw = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (raw) {
      const parsed = JSON.parse(raw);
      return { ...defaultConsent, ...parsed } as ConsentPreferences;
    }
  } catch (e) {
    // noop
  }
  return defaultConsent;
}

export function setConsent(consent: ConsentPreferences) {
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    }
  } catch (e) {
    // noop
  }
  applyConsentToGtag(consent);
}

export function applyConsentToGtag(consent: ConsentPreferences) {
  const w = typeof window !== "undefined" ? (window as any) : undefined;
  if (!w || typeof w.gtag !== "function") return;
  w.gtag("consent", "update", {
    ad_storage: consent.marketing ? "granted" : "denied",
    analytics_storage: consent.analytics ? "granted" : "denied",
    functionality_storage: consent.preferences ? "granted" : "denied",
    security_storage: "granted",
  });
}

export function initDefaultConsent() {
  const w = typeof window !== "undefined" ? (window as any) : undefined;
  if (!w || typeof w.gtag !== "function") return;
  w.gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    security_storage: "granted",
  });
}